import React from 'react';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';

const defaultSchema = require('hast-util-sanitize/lib/github.json');

export const MAX_CONTENT_LENGTH = 10_000;
export const MAX_ATTACHMENT_SIZE = 20 * 1024 * 1024;
export const ALLOWED_ATTACHMENT_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/webp',
  'text/plain',
];

export const EMPTY_PROMPT_CHIPS = [
  'Summarize this patient document in plain language.',
  'Draft a prior authorization request from this note.',
  'Extract key follow-up tasks from this message.',
  'Create a concise referral summary with next steps.',
];

export const remarkPlugins = [remarkGfm];
export const aiChatSanitizeSchema = {
  ...defaultSchema,
  tagNames: defaultSchema.tagNames.filter((tagName) => tagName !== 'img'),
};
export const rehypePlugins = [[rehypeSanitize, aiChatSanitizeSchema]];

export const markdownComponents = {
  a: ({ children, href }) => {
    const safeHref = /^https?:\/\/|^mailto:/i.test(href) ? href : undefined;
    return (
      <a href={safeHref} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
};

export const formatMessageTime = (timestamp) => {
  if (!timestamp) return '';
  const value = new Date(timestamp);
  if (Number.isNaN(value.getTime())) return '';
  return value.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

export const formatFileSize = (byteSize) => {
  if (!byteSize || byteSize < 1024) return `${byteSize || 0} B`;
  if (byteSize < 1024 * 1024) return `${(byteSize / 1024).toFixed(1)} KB`;
  return `${(byteSize / (1024 * 1024)).toFixed(1)} MB`;
};
